import { createUseStyles } from 'react-jss';

import { theme } from '@align-cpf/uikit-styles';

const { colors } = theme;

export default createUseStyles(
  {
    root: {
      cursor: 'pointer',
      color: colors.textLink,
      '&:link': {
        textDecoration: 'none',
      },
      '&:visited': {
        textDecorationColor: 'none',
      },
      '&:hover': {
        textDecoration: 'underline',
      },
      '&:active': {
        color: colors.textPrimary,
        textDecoration: 'underline',
      },
    },
    disabled: {
      pointerEvents: 'none',
      color: colors.textDisabled,
    },
  },
  {
    name: 'Link',
  },
);
